import { Group, createStyles } from '@mantine/core';
import { ListBox, Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { isValidEnumValue } from '../../../../utils/enumUtils';
import type { EditBlockStore } from '../../store';
import { AutomationEditType } from '../../types';
import { requiresEditActionValue } from '../../utils';

const useStyles = createStyles((theme) => ({
	menuItem: {
		padding: theme.spacing['2xs'],
		margin: `0 ${theme.spacing['2xs']}`,
		width: `calc(100% - (2 * ${theme.spacing['2xs']}))`,
	},
}));

export interface EditActionTypeDropdownProps {
	onItemClick: (type: AutomationEditType, shouldClose: boolean) => void;
	store: EditBlockStore;
}

export const EditActionTypeDropdown = observer(
	({ store, onItemClick }: EditActionTypeDropdownProps) => {
		const { classes } = useStyles();

		const options = useMemo(
			() => store.getEditActionOptions(store.searchTerm),
			[store.searchTerm, store] // eslint-disable-line react-hooks/exhaustive-deps
		);

		return (
			<ListBox.ItemsDropdown
				search={{
					onChange: store.setSearchTerm,
					value: store.searchTerm,
				}}
				items={options}
				renderItem={(item, getProps) => (
					<ListBox.Item
						key={item.label}
						{...getProps({
							onClick: () => {
								if (isValidEnumValue(AutomationEditType, item.value)) {
									onItemClick(item.value, !requiresEditActionValue(item.value));
								}
							},
							className: classes.menuItem,
						})}
					>
						<Group
							data-testid={`add-property-button-${item.label?.toLowerCase()}`}
							spacing="2xs"
						>
							{item.icon}
							<Text size="sm">{item.label}</Text>
						</Group>
					</ListBox.Item>
				)}
			/>
		);
	}
);
